import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Container, Alert } from '@mui/material';
import apiClient from '../../../lib/api';
import ObituaryPreview from '../../../components/ObituaryPreview';

const PublicObituaryViewPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [obituary, setObituary] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchObituary();
    }
  }, [id]);

  const fetchObituary = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiClient.getObituary(id);
      console.log('Obituary API response:', response);
      
      // The API client already extracts response.data, so response should be the obituary object directly
      // But handle both cases: { data: {...} } or {...} directly
      const obituaryData = response?.data || response;
      
      if (!obituaryData) {
        throw new Error('Obituary data is empty');
      }
      
      console.log('Setting obituary:', obituaryData);
      setObituary(obituaryData);
    } catch (error) {
      console.error('Error fetching obituary:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Failed to load obituary';
      console.error('Error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
      });
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !obituary) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error">{error || 'Obituary not found'}</Alert>
      </Container>
    );
  }

  // Get photo URL if photoId or photoUrl exists
  let photoUrl = null;
  try {
    if (obituary?.photoId || obituary?.photoUrl) {
      photoUrl = apiClient.getObituaryPhotoUrl(id);
    }
  } catch (error) {
    console.error('Error constructing photo URL:', error);
    // Continue without photo if URL construction fails
  }

  // Pass the photo URL to ObituaryPreview via the obituary object
  const obituaryWithPhoto = photoUrl 
    ? { ...obituary, photo: photoUrl }
    : obituary;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      <Container maxWidth="md" sx={{ py: 0 }}>
        <ObituaryPreview obituary={obituaryWithPhoto} />
      </Container>
    </Box>
  );
};

export default PublicObituaryViewPage;

